import React from "react";
import { Col, Row } from "antd";
import "./EnvironmentOverviewSkeleton.less";

const ComponentSearchSkeleton = () => (
    <Row gutter={[12, 12]} style={{ marginBottom: "15px" }}>
        <Col span={17}>
            <div className="skeleton-line environment-skeleton-search" />
        </Col>
        <Col span={7}>
            <div className="skeleton-line environment-skeleton-button" />
        </Col>
    </Row>
);

const ComponentMetadataSkeleton = () => (
    <div style={{ 
        display: "flex", 
        alignItems: "center",
        gap: "12px",
        padding: "0",
        width: "100%",
        minWidth: 0,
        overflow: "hidden"
    }}>
        <div style={{ flex: "1 1 auto", minWidth: 0, display: "flex", flexDirection: "column", gap: "4px", overflow: "hidden" }}>
            <div style={{ 
                display: "flex", 
                alignItems: "center", 
                gap: "8px",
                minWidth: 0
            }}>
                <div className="skeleton-line environment-skeleton-component-name" />
                <div className="skeleton-line environment-skeleton-icon" style={{ width: 16, height: 16, borderRadius: 4, flexShrink: 0 }} />
            </div>
            <div className="skeleton-line environment-skeleton-commit-info" />
        </div>
        <div style={{ flexShrink: 0 }}>
            <div className="skeleton-line environment-skeleton-status-badge" />
        </div>
    </div>
);

const ComponentAppSkeleton = () => (
    <div style={{ 
        display: "flex", 
        justifyContent: "space-between", 
        alignItems: "center",
        padding: "8px 0"
    }}>
        <div>
            <div className="skeleton-line environment-skeleton-app-name" style={{ marginBottom: "4px" }} />
            <div className="skeleton-line environment-skeleton-app-commit" />
        </div>
        <div style={{ display: "flex", gap: "4px" }}>
            {Array.from({ length: 3 }).map((_, i) => (
                <div 
                    key={i} 
                    className="skeleton-line environment-skeleton-pod-badge" 
                    style={{ width: 8, height: 8, borderRadius: "50%" }}
                />
            ))}
        </div>
    </div>
);

const ComponentItemSkeleton = ({ isCluster = false }: { isCluster?: boolean }) => (
    <div 
        className="environment-skeleton-component-item"
        style={{
            marginBottom: 10,
            padding: "16px",
            background: "#ffffff",
            borderRadius: 8,
            border: "1px solid #f0f0f0"
        }}
    >
        <ComponentMetadataSkeleton />
        {isCluster && (
            <div style={{ marginTop: "16px", paddingLeft: "24px" }}>
                {Array.from({ length: 2 }).map((_, i) => (
                    <ComponentAppSkeleton key={i} />
                ))}
                <div style={{ marginTop: "12px", paddingTop: "12px", borderTop: "1px solid #f0f0f0" }}>
                    <div className="skeleton-line environment-skeleton-add-button" style={{ 
                        width: "100%", 
                        height: 40, 
                        borderRadius: 6,
                        margin: "0 auto"
                    }} />
                </div>
            </div>
        )}
    </div>
);

const EnvironmentOverviewSkeleton = () => {
    return (
        <>
            <Col 
                xs={24} 
                sm={24} 
                md={8} 
                className="environment-overview-skeleton"
                style={{ 
                    height: "calc(100vh - 128px)", 
                    maxHeight: "calc(100vh - 128px)", 
                    display: "flex", 
                    flexDirection: "column" 
                }}
            >
                <div style={{ flexShrink: 0 }}>
                    <ComponentSearchSkeleton />
                </div>
                <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
                    {Array.from({ length: 4 }).map((_, i) => (
                        <ComponentItemSkeleton key={i} isCluster={i < 2} />
                    ))}
                </div>
            </Col>
            <Col 
                xs={24} 
                sm={24} 
                md={16} 
                className="environment-overview-skeleton"
                style={{ 
                    display: "inline-flex", 
                    alignSelf: "stretch",
                    padding: "24px"
                }}
            >
                <div style={{ width: "100%" }}>
                    <div className="skeleton-line environment-skeleton-content-header" style={{ 
                        width: "60%", 
                        height: 24, 
                        marginBottom: 24,
                        borderRadius: 6
                    }} />
                    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                        {Array.from({ length: 5 }).map((_, i) => (
                            <div key={i} style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                <div className="skeleton-line environment-skeleton-content-line" style={{ 
                                    width: i === 0 ? "100%" : i === 1 ? "85%" : i === 2 ? "70%" : i === 3 ? "90%" : "60%",
                                    height: 16,
                                    borderRadius: 4
                                }} />
                            </div>
                        ))}
                    </div>
                    <div style={{ marginTop: 32, display: "flex", gap: 16 }}>
                        {Array.from({ length: 3 }).map((_, i) => (
                            <div 
                                key={i} 
                                className="skeleton-line environment-skeleton-content-card" 
                                style={{ 
                                    flex: 1, 
                                    height: 120, 
                                    borderRadius: 8 
                                }} 
                            />
                        ))}
                    </div>
                </div>
            </Col>
        </>
    );
};

export default EnvironmentOverviewSkeleton;
